(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-divisions"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAboutDivisions(root) {
    if (!root || root.dataset.aboutDivReady === 'true') return;
    root.dataset.aboutDivReady = 'true';

    var track = root.querySelector('[data-about-div-track]');
    var dotsWrap = root.querySelector('[data-about-div-dots]');
    if (!track || !dotsWrap) return;

    var cards = track.querySelectorAll('.pca-about-div__card');
    if (!cards.length) return;

    function gapSize() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 16;
    }

    function cardStep() {
      return cards[0].getBoundingClientRect().width + gapSize();
    }

    function pageCount() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 2) return 1;
      var step = cardStep();
      if (step <= 0) return 1;
      /* Dynamic: one page per remaining scroll step so added divisions update dots */
      return Math.max(1, Math.round(maxScroll / step) + 1);
    }

    function renderDots() {
      var count = pageCount();
      var activeIndex = 0;
      var current = dotsWrap.querySelector('.pca-about-div__dot.is-active');
      if (current) {
        activeIndex = Array.prototype.indexOf.call(dotsWrap.children, current);
      }
      dotsWrap.innerHTML = '';
      dotsWrap.hidden = count <= 1;
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pca-about-div__dot' + (i === Math.min(activeIndex, count - 1) ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.setAttribute('role', 'tab');
        dot.addEventListener(
          'click',
          (function (index) {
            return function () {
              var max = track.scrollWidth - track.clientWidth;
              var left = count <= 1 ? 0 : (max * index) / (count - 1);
              track.scrollTo({ left: left, behavior: 'smooth' });
            };
          })(i)
        );
        dotsWrap.appendChild(dot);
      }
      syncDots();
    }

    function syncDots() {
      var dots = dotsWrap.querySelectorAll('.pca-about-div__dot');
      if (!dots.length) return;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max <= 0 ? 0 : track.scrollLeft / max;
      var index = Math.round(ratio * (dots.length - 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
        if (i === index) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    var resizeTimer;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        renderDots();
      }, 100);
    }

    renderDots();
    track.addEventListener('scroll', syncDots, { passive: true });
    window.addEventListener('resize', onResize);
  }

  document.querySelectorAll('[data-about-divisions]').forEach(initAboutDivisions);
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var found = event.target.matches && event.target.matches('[data-about-divisions]')
      ? event.target
      : event.target.querySelector('[data-about-divisions]');
    if (found) {
      found.dataset.aboutDivReady = '';
      initAboutDivisions(found);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAboutHero(root) {
    if (!root || root.dataset.aboutHeroReady === 'true') return;
    root.dataset.aboutHeroReady = 'true';

    var track = root.querySelector('[data-about-hero-track]');
    var dotsWrap = root.querySelector('[data-about-hero-dots]');
    if (!track || !dotsWrap) return;

    var cards = track.querySelectorAll('.division-card');
    if (!cards.length) return;

    function gapSize() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap) || 20;
    }

    function cardStep() {
      return cards[0].getBoundingClientRect().width + gapSize();
    }

    function pageCount() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 2) return 1;
      var step = cardStep();
      if (step <= 0) return 1;
      return Math.max(1, Math.round(maxScroll / step) + 1);
    }

    function renderDots() {
      var count = pageCount();
      var activeIndex = 0;
      var current = dotsWrap.querySelector('.about-hero__dot.is-active');
      if (current) {
        activeIndex = Array.prototype.indexOf.call(dotsWrap.children, current);
      }
      dotsWrap.innerHTML = '';
      dotsWrap.hidden = count <= 1;
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'about-hero__dot' + (i === Math.min(activeIndex, count - 1) ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.setAttribute('role', 'tab');
        dot.addEventListener(
          'click',
          (function (index) {
            return function () {
              var max = track.scrollWidth - track.clientWidth;
              var left = count <= 1 ? 0 : (max * index) / (count - 1);
              track.scrollTo({ left: left, behavior: 'smooth' });
            };
          })(i)
        );
        dotsWrap.appendChild(dot);
      }
      syncDots();
    }

    function syncDots() {
      var dots = dotsWrap.querySelectorAll('.about-hero__dot');
      if (!dots.length) return;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max <= 0 ? 0 : track.scrollLeft / max;
      var index = Math.round(ratio * (dots.length - 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
        if (i === index) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    var resizeTimer;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(renderDots, 100);
    }

    renderDots();
    track.addEventListener('scroll', syncDots, { passive: true });
    window.addEventListener('resize', onResize);
  }

  document.querySelectorAll('[data-about-hero]').forEach(initAboutHero);
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var found = event.target.matches && event.target.matches('[data-about-hero]')
      ? event.target
      : event.target.querySelector('[data-about-hero]');
    if (found) {
      found.dataset.aboutHeroReady = '';
      initAboutHero(found);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capabilities-divisions"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Duration must match the CSS transition on .pca-cap-panel (opacity/background-color). */
  var CAP_TRANSITION_MS = 420;

  function initCapDivisions(root) {
    if (!root || root.dataset.capDivReady === 'true') return;

    root.dataset.capDivReady = 'true';

    var tabs = root.querySelectorAll('[data-cap-div]');
    var panels = root.querySelectorAll('[data-cap-panel]');

    if (!tabs.length) return;

    /*
     * Cross-dissolve between divisions: the outgoing panel and the
     * incoming panel are stacked on top of each other (see the CSS grid
     * stacking on .pca-cap-panels) and fade concurrently -- the outgoing
     * panel from opaque to transparent while the incoming panel fades from
     * transparent to opaque at the same time, over the same duration. That
     * simultaneous overlap is what produces the color-blend/dissolve look
     * (rather than a sequential fade-out-then-fade-in with a gap). The
     * surrounding layout (nav, grid, card positions/sizes) never moves.
     */
    function activate(tab) {
      if (tab.classList.contains('is-active') || tab.dataset.capSwitching === 'true') {
        return;
      }

      tabs.forEach(function (item) {
        var on = item === tab;

        item.classList.toggle('is-active', on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
        item.setAttribute('tabindex', on ? '0' : '-1');
      });

      var targetId = tab.getAttribute('data-target');
      var currentPanel = null;
      var nextPanel = null;

      panels.forEach(function (panel) {
        if (panel.id === targetId) {
          nextPanel = panel;
        } else if (!panel.classList.contains('is-hidden')) {
          currentPanel = panel;
        }
      });

      if (!nextPanel || nextPanel === currentPanel) return;

      tab.dataset.capSwitching = 'true';

      if (!currentPanel) {
        // Nothing to cross-dissolve from (first paint) -- just reveal it.
        nextPanel.removeAttribute('hidden');
        nextPanel.classList.remove('is-hidden');
        void nextPanel.offsetWidth;
        nextPanel.classList.remove('is-entering');
        tab.dataset.capSwitching = 'false';
        return;
      }

      // 1. Bring the incoming panel into the layout, stacked directly on
      //    top of the outgoing one, starting fully transparent.
      nextPanel.removeAttribute('hidden');
      nextPanel.classList.remove('is-hidden');
      nextPanel.classList.add('is-entering');

      // Force layout so the "start transparent" state registers before we
      // transition it, otherwise the browser may coalesce it with the next
      // style change and skip the fade-in entirely.
      void nextPanel.offsetWidth;

      // 2. On the next frame, fade the outgoing panel out and the incoming
      //    panel in at the same time (true cross-dissolve, not sequential).
      requestAnimationFrame(function () {
        currentPanel.classList.add('is-leaving');
        nextPanel.classList.remove('is-entering');

        window.setTimeout(function () {
          currentPanel.classList.remove('is-leaving');
          currentPanel.classList.add('is-hidden');
          currentPanel.setAttribute('hidden', '');
          tab.dataset.capSwitching = 'false';
        }, CAP_TRANSITION_MS);
      });
    }

    /*
     * Activate a division from the URL.
     *
     * Example:
     * /pages/capabilities?division=distribution
     * /pages/capabilities?division=logistics
     * /pages/capabilities?division=ecommerce
     * /pages/capabilities?division=retail
     * /pages/capabilities?division=creative
     * /pages/capabilities?division=product
     */
    function activateFromURL() {
      var params = new URLSearchParams(window.location.search);
      var division = params.get('division');

      if (!division) return;

      division = division.toLowerCase().trim();

      var targetTab = null;

      tabs.forEach(function (tab) {
        var tabDivision = tab.getAttribute('data-division');

        if (
          !targetTab &&
          tabDivision &&
          tabDivision.toLowerCase().trim() === division
        ) {
          targetTab = tab;
        }
      });

      if (targetTab) {
        activate(targetTab);

        /*
         * On mobile, bring the selected division into view
         * without jumping the whole page unnecessarily.
         */
        if (window.matchMedia('(max-width: 767px)').matches) {
          setTimeout(function () {
            targetTab.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          }, 100);
        }
      }
    }

    tabs.forEach(function (tab, index) {
      if (index !== 0) {
        tab.setAttribute('tabindex', '-1');
      }

      tab.addEventListener('click', function () {
        activate(tab);
      });

      tab.addEventListener('keydown', function (event) {
        var next = -1;

        if (
          event.key === 'ArrowDown' ||
          event.key === 'ArrowRight'
        ) {
          next = index + 1;
        }

        if (
          event.key === 'ArrowUp' ||
          event.key === 'ArrowLeft'
        ) {
          next = index - 1;
        }

        if (event.key === 'Home') {
          next = 0;
        }

        if (event.key === 'End') {
          next = tabs.length - 1;
        }

        if (next === -1) return;

        event.preventDefault();

        var target = tabs[(next + tabs.length) % tabs.length];

        activate(target);
        target.focus();
      });
    });

    /*
     * Default behavior:
     * First division remains active when no ?division=... exists.
     *
     * If ?division=... exists, the matching division becomes active.
     */
    activateFromURL();
  }

  function initCapFacts(root) {
    var facts = root.querySelectorAll('[data-cap-fact]');

    facts.forEach(function (fact) {
      var btn = fact.querySelector('.pca-cap-fact__summary');
      var body = fact.querySelector('.pca-cap-fact__body');

      if (!btn || btn.dataset.capFactReady === 'true') return;
      btn.dataset.capFactReady = 'true';

      /*
       * Fact 1 ("hero" card) is permanently open on mobile and must never
       * be collapsible -- pointer-events is disabled on its summary via
       * CSS, so this click handler is a no-op safeguard for that card.
       */
      var isLocked = fact.classList.contains('pca-cap-fact--1');

      // Facts open by default (e.g. fact--1) should start fully expanded, no animation.
      if (fact.classList.contains('is-open') && body) {
        body.style.maxHeight = 'none';
      }

      btn.addEventListener('click', function () {
        if (isLocked) return;

        var willOpen = !fact.classList.contains('is-open');

        fact.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

        if (!body) return;

        if (willOpen) {
          body.style.maxHeight = '0px';
          void body.offsetHeight; // force reflow so the 0px start state registers
          body.style.maxHeight = body.scrollHeight + 'px';

          body.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'max-height') {
              body.style.maxHeight = 'none'; // let it breathe if content reflows later
              body.removeEventListener('transitionend', handler);
            }
          });
        } else {
          body.style.maxHeight = body.scrollHeight + 'px';
          void body.offsetHeight;
          body.style.maxHeight = '0px';
        }
      });
    });
  }

  /*
   * Initial page load
   */
  document
    .querySelectorAll('[data-capabilities-divisions]')
    .forEach(function (root) {
      initCapDivisions(root);
      initCapFacts(root);
    });

  /*
   * Shopify theme editor section reload
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (!event.target.querySelector) return;

      var found =
        event.target.matches &&
        event.target.matches('[data-capabilities-divisions]')
          ? event.target
          : event.target.querySelector(
              '[data-capabilities-divisions]'
            );

      if (found) {
        initCapDivisions(found);
        initCapFacts(found);
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capabilities-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCapHero(root) {
    if (!root || root.dataset.capHeroReady === 'true') return;
    root.dataset.capHeroReady = 'true';

    var track = root.querySelector('[data-cap-pills-track]');
    var group = root.querySelector('[data-cap-pills-group]');
    if (!track || !group) return;

    var minWidth = Math.max(window.innerWidth * 2, group.scrollWidth * 2);
    while (track.scrollWidth < minWidth) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-cap-pills-group');
      track.appendChild(clone);
    }

    track.style.setProperty('--cap-pills-shift', group.scrollWidth + 'px');
    track.classList.add('is-animating');
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-capabilities-hero]').forEach(initCapHero);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var root = event.target.querySelector('[data-capabilities-hero]') || event.target;
    if (root && root.hasAttribute && root.hasAttribute('data-capabilities-hero')) {
      root.dataset.capHeroReady = 'false';
      initCapHero(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capabilities-services"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FADE_MS = 420;

  function scrollTabIntoView(root, tab) {
    if (!root || !tab) return;

    var tabsWrap = root.querySelector(
      '.pca-cap-services__tabs-wrap'
    );

    if (!tabsWrap) return;

    var wrapRect = tabsWrap.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();

    var left =
      tabsWrap.scrollLeft +
      (tabRect.left - wrapRect.left) -
      (wrapRect.width - tabRect.width) / 2;

    tabsWrap.scrollTo({
      left: Math.max(0, left),
      behavior: window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
        ? 'auto'
        : 'smooth'
    });
  }


  function activate(root, tab) {
    if (!root || !tab) return;

    var tabs = root.querySelectorAll('[data-svc-tab]');

    var targetId = tab.getAttribute('data-target');

    var target = targetId
      ? root.querySelector('#' + CSS.escape(targetId))
      : null;

    var current = root.querySelector(
      '[data-svc-panel].is-active'
    );

    var reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (!target) return;

    scrollTabIntoView(root, tab);

    tabs.forEach(function (item) {
      var on = item === tab;

      item.classList.toggle('is-active', on);

      item.setAttribute(
        'aria-selected',
        on ? 'true' : 'false'
      );
    });


    if (!current || current === target) {
      target.classList.add('is-active');
      target.classList.remove(
        'is-entering',
        'is-leaving'
      );

      target.removeAttribute('hidden');

      return;
    }


    if (reduceMotion) {
      current.classList.remove(
        'is-active',
        'is-leaving'
      );

      current.setAttribute('hidden', '');

      target.classList.add('is-active');

      target.classList.remove('is-entering');

      target.removeAttribute('hidden');

      return;
    }


    root.dataset.capSvcSwitching = 'true';

    target.removeAttribute('hidden');

    target.classList.add('is-entering');

    void target.offsetWidth;


    requestAnimationFrame(function () {
      current.classList.remove('is-active');

      current.classList.add('is-leaving');

      target.classList.remove('is-entering');

      target.classList.add('is-active');


      setTimeout(function () {
        current.classList.remove('is-leaving');

        current.setAttribute('hidden', '');

        root.dataset.capSvcSwitching = 'false';
      }, FADE_MS);
    });
  }


  /*
   * Drag-to-scroll + mouse wheel horizontal scrolling
   */
function initDragScroll(strip) {
  if (!strip || strip.dataset.dragReady === 'true') {
    return;
  }

  strip.dataset.dragReady = 'true';

  var isDragging = false;
  var startX = 0;
  var startScrollLeft = 0;


  /*
   * -----------------------------------------
   * EXTERNAL MOUSE WHEEL
   * -----------------------------------------
   */
  strip.addEventListener(
    'wheel',
    function (event) {
      var deltaX = event.deltaX;
      var deltaY = event.deltaY;

      /*
       * If the mouse/trackpad already provides
       * horizontal scrolling, keep native behavior.
       */
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        return;
      }

      var maxScrollLeft =
        strip.scrollWidth - strip.clientWidth;

      if (maxScrollLeft <= 0) {
        return;
      }

      var currentScroll = strip.scrollLeft;

      var nextScroll =
        currentScroll + deltaY;

      /*
       * Only take over the wheel when the
       * horizontal strip can actually move.
       */
      if (
        (deltaY > 0 && currentScroll < maxScrollLeft) ||
        (deltaY < 0 && currentScroll > 0)
      ) {
        event.preventDefault();

        strip.scrollLeft = Math.max(
          0,
          Math.min(
            maxScrollLeft,
            nextScroll
          )
        );
      }
    },
    {
      passive: false
    }
  );


  /*
   * -----------------------------------------
   * MOUSE / TOUCH DRAG
   * -----------------------------------------
   */

  strip.addEventListener(
    'pointerdown',
    function (event) {
      /*
       * FIX: Ignore touch events. Let mobile phones use their own native,
       * hardware-accelerated smooth scrolling instead of JS calculations.
       */
      if (event.pointerType === 'touch') {
        return; 
      }

      /*
       * Only left mouse button.
       */
      if (
        event.pointerType === 'mouse' &&
        event.button !== 0
      ) {
        return;
      }

      isDragging = true;

      startX = event.clientX;

      startScrollLeft = strip.scrollLeft;

      strip.classList.add('is-dragging');

      /*
       * Keep receiving pointer movement even
       * if pointer temporarily leaves the element.
       */
      if (strip.setPointerCapture) {
        strip.setPointerCapture(
          event.pointerId
        );
      }

      /*
       * Prevent selecting text/images while dragging.
       */
      event.preventDefault();
    }
  );


  strip.addEventListener(
    'pointermove',
    function (event) {
      if (!isDragging) return;

      var distance =
        event.clientX - startX;

      /*
       * Direct 1:1 movement.
       * No smooth animation here.
       */
      strip.scrollLeft =
        startScrollLeft - distance;

      event.preventDefault();
    }
  );


  function stopDrag(event) {
    if (!isDragging) return;

    isDragging = false;

    strip.classList.remove(
      'is-dragging'
    );

    if (
      event &&
      strip.releasePointerCapture &&
      strip.hasPointerCapture &&
      strip.hasPointerCapture(
        event.pointerId
      )
    ) {
      strip.releasePointerCapture(
        event.pointerId
      );
    }
  }


  strip.addEventListener(
    'pointerup',
    stopDrag
  );

  strip.addEventListener(
    'pointercancel',
    stopDrag
  );


}


  /*
   * -----------------------------------------
   * INITIALIZE CAPABILITIES SERVICES
   * -----------------------------------------
   */
  function initCapServices(root) {

    if (
      !root ||
      root.dataset.capSvcReady === 'true'
    ) {
      return;
    }


    root.dataset.capSvcReady = 'true';


    /*
     * Initialize image strips.
     */
    var strips =
      root.querySelectorAll(
        '[data-svc-strip]'
      );


    strips.forEach(function (strip) {
      initDragScroll(strip);
    });


    /*
     * Initialize tabs.
     */
    var tabs =
      root.querySelectorAll(
        '[data-svc-tab]'
      );


    if (!tabs.length) return;


    tabs.forEach(function (tab) {

      tab.addEventListener(
        'click',
        function () {
          activate(
            root,
            tab
          );
        }
      );

    });


    /*
     * Keep the active tab visible.
     */
    var activeTab =
      root.querySelector(
        '[data-svc-tab].is-active'
      );


    if (activeTab) {
      scrollTabIntoView(
        root,
        activeTab
      );
    }
  }


  /*
   * -----------------------------------------
   * INITIAL PAGE LOAD
   * -----------------------------------------
   */
  document
    .querySelectorAll(
      '[data-capabilities-services]'
    )
    .forEach(
      initCapServices
    );


  /*
   * -----------------------------------------
   * SHOPIFY THEME EDITOR
   * -----------------------------------------
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        !event.target.querySelector
      ) {
        return;
      }


      var found =
        event.target.matches &&
        event.target.matches(
          '[data-capabilities-services]'
        )
          ? event.target
          : event.target.querySelector(
              '[data-capabilities-services]'
            );


      if (found) {

        found.dataset.capSvcReady =
          'false';


        initCapServices(found);
      }
    }
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-studies-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-case-studies]').forEach(function (root) {
    var filters = root.querySelector('[data-cs-filters]');
    var grid = root.querySelector('[data-cs-grid]');
    if (!filters || !grid) return;

    var cards = grid.querySelectorAll('.pca-cs-card');

    function applyFilter(value) {
      cards.forEach(function (card) {
        var categories = card.getAttribute('data-categories') || '';
        var list = categories.split(',').filter(Boolean);
        var match = value === 'all' || list.indexOf(value) !== -1;
        card.classList.toggle('is-filtered-out', !match);
        card.setAttribute('aria-hidden', match ? 'false' : 'true');
      });
    }

    filters.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-filter]');
      if (!btn || !filters.contains(btn)) return;

      var value = btn.getAttribute('data-filter') || 'all';
      filters.querySelectorAll('[data-filter]').forEach(function (button) {
        var active = button === btn;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      applyFilter(value);
    });

    applyFilter('all');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-study-accelerated"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Duration must match the CSS transition on .pca-csx__panel opacity. */
  var CSX_TRANSITION_MS = 420;

  document.querySelectorAll('[data-case-study-accelerated]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-csx-tab]');
    var panels = root.querySelectorAll('[data-csx-panel]');
    var tabsTrack = root.querySelector('.pca-csx__tabs');

    if (!tabs.length) return;

    function scrollTabIntoView(tab) {
      if (!tabsTrack || !tab) return;

      var reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      var trackRect = tabsTrack.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();

      var left =
        tabsTrack.scrollLeft +
        (tabRect.left - trackRect.left) -
        (trackRect.width - tabRect.width) / 2;

      tabsTrack.scrollTo({
        left: Math.max(0, left),
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    /*
     * Cross-dissolve between periods: the outgoing panel and the incoming
     * panel are stacked in the same grid cell (see .pca-csx__panels) and
     * fade concurrently -- outgoing opacity 1 -> 0 while incoming opacity
     * 0 -> 1, over the same duration -- instead of the previous instant
     * display:none/flex swap, which against the black background read as
     * a hard cut rather than a fade.
     */
    function activateTab(tab) {
      if (
        tab.classList.contains('is-active') ||
        tab.dataset.csxSwitching === 'true'
      ) {
        return;
      }

      var target = tab.getAttribute('data-csx-tab');

      tabs.forEach(function (button) {
        var active = button === tab;

        button.classList.toggle('is-active', active);
        button.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );
      });

      var currentPanel = null;
      var nextPanel = null;

      panels.forEach(function (panel) {
        if (panel.getAttribute('data-csx-panel') === target) {
          nextPanel = panel;
        } else if (panel.classList.contains('is-active')) {
          currentPanel = panel;
        }
      });

      scrollTabIntoView(tab);

      if (!nextPanel || nextPanel === currentPanel) return;

      tab.dataset.csxSwitching = 'true';

      if (!currentPanel) {
        // Nothing to cross-dissolve from (first paint) -- just reveal it.
        nextPanel.removeAttribute('hidden');
        nextPanel.classList.add('is-active');
        tab.dataset.csxSwitching = 'false';
        return;
      }

      // 1. Bring the incoming panel into the layout, stacked directly on
      //    top of the outgoing one, starting fully transparent.
      nextPanel.removeAttribute('hidden');
      nextPanel.classList.add('is-entering');

      // Force layout so the "start transparent" state registers before we
      // transition it, otherwise the browser may coalesce it with the
      // next style change and skip the fade-in entirely.
      void nextPanel.offsetWidth;

      // 2. On the next frame, fade the outgoing panel out and the
      //    incoming panel in at the same time (true cross-dissolve, not
      //    sequential fade-out-then-fade-in).
      requestAnimationFrame(function () {
        currentPanel.classList.remove('is-active');
        currentPanel.classList.add('is-leaving');

        nextPanel.classList.remove('is-entering');
        nextPanel.classList.add('is-active');

        window.setTimeout(function () {
          currentPanel.classList.remove('is-leaving');
          currentPanel.setAttribute('hidden', '');
          tab.dataset.csxSwitching = 'false';
        }, CSX_TRANSITION_MS);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    // Keep the first active tab visible on initial load
    var activeTab = root.querySelector(
      '[data-csx-tab].is-active'
    );

    if (activeTab) {
      scrollTabIntoView(activeTab);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-study-detail"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-case-study-detail]').forEach(function (root) {
    var timeline = root.querySelector('[data-csd-timeline]');
    if (timeline) {
      var tabs = timeline.querySelectorAll('[data-csd-tab]');
      var panels = timeline.querySelectorAll('[data-csd-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-csd-tab');
          tabs.forEach(function (button) {
            var active = button === tab;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            var active = panel.getAttribute('data-csd-panel') === target;
            panel.classList.toggle('is-active', active);
            if (active) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });
        });
      });
    }

    var track = root.querySelector('[data-csd-related-track]');
    var dotsWrap = root.querySelector('[data-csd-related-dots]');
    if (!track || !dotsWrap) return;

    var cards = track.children;
    if (!cards.length) return;

    function visibleCount() {
      if (window.innerWidth <= 768) return 1;
      if (window.innerWidth <= 1100) return 2;
      return 4;
    }

    function renderDots() {
      var count = Math.max(1, Math.ceil(cards.length / visibleCount()));
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pca-csd__related-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function (index) {
          return function () {
            var card = cards[0];
            if (!card) return;
            var gap = window.innerWidth <= 768 ? 16 : 16;
            var pageWidth = (card.getBoundingClientRect().width + gap) * visibleCount();
            track.scrollTo({ left: pageWidth * index, behavior: 'smooth' });
          };
        }(i));
        dotsWrap.appendChild(dot);
      }
    }

    function syncDots() {
      var dots = dotsWrap.querySelectorAll('.pca-csd__related-dot');
      if (!dots.length) return;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max <= 0 ? 0 : track.scrollLeft / max;
      var index = Math.round(ratio * (dots.length - 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    renderDots();
    track.addEventListener('scroll', syncDots, { passive: true });
    window.addEventListener('resize', function () {
      renderDots();
      syncDots();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-study-related"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-case-study-related]').forEach(function (root) {
    var track = root.querySelector('[data-csr-track]');
    var dotsWrap = root.querySelector('[data-csr-dots]');
    if (!track || !dotsWrap) return;

    var cards = track.children;
    if (!cards.length) return;

    function visibleCount() {
      if (window.innerWidth <= 768) return 1;
      if (window.innerWidth <= 1100) return 2;
      return 4;
    }

    function renderDots() {
      var count = Math.max(1, Math.ceil(cards.length / visibleCount()));

      // Everything fits in a single view — nothing to page through, so hide the dots.
      if (count <= 1) {
        dotsWrap.innerHTML = '';
        dotsWrap.style.display = 'none';
        return;
      }
      dotsWrap.style.display = '';

      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pca-csr__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener(
          'click',
          (function (index) {
            return function () {
              var card = cards[0];
              if (!card) return;
              var gap = 16;
              var pageWidth = (card.getBoundingClientRect().width + gap) * visibleCount();
              track.scrollTo({ left: pageWidth * index, behavior: 'smooth' });
            };
          })(i)
        );
        dotsWrap.appendChild(dot);
      }
    }

    function syncDots() {
      var dots = dotsWrap.querySelectorAll('.pca-csr__dot');
      if (!dots.length) return;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max <= 0 ? 0 : track.scrollLeft / max;
      var index = Math.round(ratio * (dots.length - 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    renderDots();
    track.addEventListener('scroll', syncDots, { passive: true });
    window.addEventListener('resize', function () {
      renderDots();
      syncDots();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clients-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('[data-toggle-logos]');

  buttons.forEach(button => {
    const grid = document.getElementById(button.getAttribute('aria-controls'));
    const label = button.querySelector('[data-toggle-label]');

    if (!grid) return;

    function updateView() {
      const width = window.innerWidth;

      if (width > 1024) {
        button.style.display = 'none';
        grid.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'true');
        return;
      }

      button.style.display = 'inline-flex';

      const expanded = grid.classList.contains('is-expanded');

      button.setAttribute('aria-expanded', expanded);
      label.textContent = expanded ? 'SEE LESS' : 'SEE MORE';
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      grid.classList.toggle('is-expanded');
      updateView();
    });

    window.addEventListener('resize', updateView);

    updateView();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distribution-services"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.solutions-slider');
  if (!slider) return;

  const track = slider.querySelector('.solutions-track');
  const slides = slider.querySelectorAll('.solution-slide');
  const footer = slider.querySelector('.solution-footer');

  if (!track || slides.length < 1 || !footer) return;

  const footerLeft = footer.querySelector('span');
  const footerRight = footer.querySelector('a');

  let index = 0;
  let isLocked = false;
  let touchStartX = 0;
  let touchStartY = 0;

  function clampIndex(nextIndex) {
    if (nextIndex < 0) return 0;
    if (nextIndex > slides.length - 1) return slides.length - 1;
    return nextIndex;
  }

  function updateSlider() {
    // slide move
    track.style.transform = `translateX(-${index * 100}%)`;

    // current slide
    const current = slides[index];

    // footer update
    footer.style.background = current.dataset.bg;
    footer.style.color = current.dataset.text;

    footerLeft.textContent = current.dataset.left;
    footerRight.textContent = current.dataset.right;
    footerRight.style.color = current.dataset.text;
  }

  function moveSlide(direction) {
    if (isLocked) return;

    const next = clampIndex(index + direction);
    if (next === index) return;

    isLocked = true;
    index = next;

    updateSlider();

    setTimeout(() => {
      isLocked = false;
    }, 650);
  }

  // scroll
slider.addEventListener(
  'wheel',
  function (event) {
    if (Math.abs(event.deltaY) < 12) return;

    const goingDown = event.deltaY > 0;
    const goingUp = event.deltaY < 0;

    // 👉 FIRST SLIDE + SCROLL UP → allow page scroll
    if (index === 0 && goingUp) {
      return;
    }

    // 👉 LAST SLIDE + SCROLL DOWN → allow page scroll
    if (index === slides.length - 1 && goingDown) {
      return;
    }

    // 👉 otherwise slider move
    event.preventDefault();
    moveSlide(goingDown ? 1 : -1);
  },
  { passive: false }
);

  // touch start
  slider.addEventListener(
    'touchstart',
    function (event) {
      if (!event.touches || !event.touches[0]) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    },
    { passive: true }
  );

  // touch end
  slider.addEventListener(
    'touchend',
    function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;

      const touchEndX = event.changedTouches[0].clientX;
      const touchEndY = event.changedTouches[0].clientY;

      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;

      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 40) {
        moveSlide(deltaX < 0 ? 1 : -1);
      } else if (Math.abs(deltaY) > 40) {
        moveSlide(deltaY < 0 ? 1 : -1);
      }
    },
    { passive: true }
  );

  // 🔥 IMPORTANT — initial load footer set
  updateSlider();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-work"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tracks = document.querySelectorAll('[data-featured-track]');
  tracks.forEach(function (track) {
  var dotsWrap = track.parentElement.querySelector('[data-featured-dots]');
  if (!track || !dotsWrap) return;

  var cards = track.children;
  if (!cards.length) return;

  function pageCount() {
    var visible = window.innerWidth <= 768 ? 1 : window.innerWidth <= 1100 ? 2 : 4;
    return Math.max(1, Math.ceil(cards.length / visible));
  }

  function gapSize() {
    return window.innerWidth <= 768 ? 16 : 24;
  }

  function visibleCount() {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 1100) return 2;
    return 4;
  }

  function renderDots() {
  var count = pageCount();

  if (count <= 1) {
    dotsWrap.innerHTML = '';
    dotsWrap.style.display = 'none';
    return;
  }

  dotsWrap.style.display = '';
  dotsWrap.innerHTML = '';
  for (var i = 0; i < count; i++) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'pca-featured__dot' + (i === 0 ? ' is-active' : '');
    dot.setAttribute('aria-label', 'Slide ' + (i + 1));
    dot.addEventListener('click', function (index) {
      return function () {
        var card = cards[0];
        if (!card) return;
        var pageWidth = (card.getBoundingClientRect().width + gapSize()) * visibleCount();
        track.scrollTo({ left: pageWidth * index, behavior: 'smooth' });
      };
    }(i));
    dotsWrap.appendChild(dot);
  }
}

  function syncDots() {
    var dots = dotsWrap.querySelectorAll('.pca-featured__dot');
    if (!dots.length) return;
    var max = track.scrollWidth - track.clientWidth;
    var ratio = max <= 0 ? 0 : track.scrollLeft / max;
    var index = Math.round(ratio * (dots.length - 1));
    dots.forEach(function (dot, i) {
      if (i === index) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  renderDots();
  track.addEventListener('scroll', syncDots, { passive: true });
  window.addEventListener('resize', function () {
    renderDots();
    syncDots();
  });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header = document.querySelector('[data-pca-header]');
  if (!header) return;

  var btn = header.querySelector('[data-pca-header-menu]');
  var drawer = header.querySelector('[data-pca-header-drawer]');
  if (!btn || !drawer) return;

  var lastFocus = null;

  function setOpen(open) {
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  btn.setAttribute('aria-label', open ? btn.getAttribute('data-close-label') : btn.getAttribute('data-open-label'));

  if (open) {
    drawer.removeAttribute('hidden');
    drawer.style.maxHeight = '0px';
    // force a reflow so the browser registers the 0px start state
    void drawer.offsetHeight;
    header.classList.add('is-open');
    drawer.style.maxHeight = drawer.scrollHeight + 'px';
    document.documentElement.classList.add('drawer-open');
    lastFocus = document.activeElement;
  } else {
    drawer.style.maxHeight = drawer.scrollHeight + 'px';
    void drawer.offsetHeight;
    header.classList.remove('is-open');
    drawer.style.maxHeight = '0px';

    setTimeout(function () {
      drawer.setAttribute('hidden', '');
      drawer.style.maxHeight = '';
    }, 350);

    document.documentElement.classList.remove('drawer-open');
    if (lastFocus) lastFocus.focus();
  }
}

  btn.addEventListener('click', function () {
    setOpen(btn.getAttribute('aria-expanded') !== 'true');
  });

  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      setOpen(false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-hero]').forEach(function (root) {
    var track = root.querySelector('[data-hero-track]');
    var viewport = root.querySelector('.pca-hero__viewport');
    var dots = root.querySelectorAll('[data-hero-dot]');
    if (!track) return;

    var slides = track.children;
    var index = 0;
    var touchStartX = 0;

    function isCarousel() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function syncDots() {
      var i;
      for (i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].classList.add('is-active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('is-active');
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    // FIX: each slide is now full viewport width (100%), not (100% - gap).
    // The 16px gap only ever shows up *between* slides (via the flex `gap`
    // on the track), so it must also only be added *between* steps in the
    // translate math — not subtracted from each slide's own width. That
    // mismatch was what made the visible slide sit 16px narrower than the
    // viewport, leaving uneven space on one side.
    function applyTransform() {
      if (isCarousel()) {
        var gap = 16;
        var slideWidth = track.parentElement.clientWidth;

        track.style.transform =
          'translateX(-' + index * (slideWidth + gap) + 'px)';
      } else {
        track.style.transform = '';
      }
    }

    function goTo(nextIndex) {
      if (!slides.length) return;
      index = ((nextIndex % slides.length) + slides.length) % slides.length;
      applyTransform();
      syncDots();
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(target)) goTo(target);
      });
    });

    if (viewport) {
      viewport.addEventListener(
        'touchstart',
        function (event) {
          if (!isCarousel()) return;
          touchStartX = event.changedTouches[0].screenX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        function (event) {
          if (!isCarousel()) return;
          var touchEndX = event.changedTouches[0].screenX;
          var diff = touchStartX - touchEndX;
          if (Math.abs(diff) < 50) return;
          if (diff > 0) goTo(index + 1);
          else goTo(index - 1);
        },
        { passive: true }
      );
    }

    window.addEventListener('resize', function () {
      applyTransform();
    });
    goTo(0);
  });

  if (!window.__pcaFeatureImageInit) {
    window.__pcaFeatureImageInit = true;

    function preloadFeatureImage(el) {
      if (!el || el.complete) return;
      var src = el.currentSrc || el.src;
      if (!src) return;
      var loader = new Image();
      loader.decoding = 'async';
      loader.src = src;
    }

    function initFeatureImageSlideshow(box) {
      if (box.dataset.initialized === 'true') return;

      var slides = box.querySelectorAll('.feature-image__el');
      if (slides.length < 2) return;

      box.dataset.initialized = 'true';

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;
      var delay = parseInt(box.getAttribute('data-interval'), 10) || 5000;
      var fadeMs = parseInt(box.getAttribute('data-transition'), 10) || 900;
      var timer = null;
      var leavingTimer = null;

      preloadFeatureImage(slides[1]);

      function show(nextIndex) {
        var next = ((nextIndex % slides.length) + slides.length) % slides.length;
        if (next === current) return;

        var outgoing = slides[current];
        var incoming = slides[next];

        preloadFeatureImage(slides[(next + 1) % slides.length]);

        if (leavingTimer) {
          clearTimeout(leavingTimer);
          leavingTimer = null;
        }

        outgoing.classList.remove('is-active');
        incoming.classList.remove('is-leaving');
        incoming.classList.add('is-active');

        if (!reduceMotion) {
          outgoing.classList.add('is-leaving');
          leavingTimer = setTimeout(function () {
            outgoing.classList.remove('is-leaving');
            leavingTimer = null;
          }, fadeMs);
        }

        current = next;
      }

      function play() {
        stop();
        if (reduceMotion) return;
        timer = setInterval(function () {
          show(current + 1);
        }, delay);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', play);
      box.addEventListener('focusin', stop);
      box.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else play();
      });

      play();
    }

    function initFeatureImages() {
      document.querySelectorAll('[data-feature-image][data-mode="slideshow"]').forEach(initFeatureImageSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFeatureImages);
    } else {
      initFeatureImages();
    }

    document.addEventListener('shopify:section:load', initFeatureImages);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
